/* import __COLOCATED_TEMPLATE__ from './standard-header.hbs'; */
/* RESPONSIBLE TEAM: team-frontend-tech */

import type AppService from 'embercom/services/app-service';
import type Model from '@ember-data/model';
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import RouteRegexes from 'embercom/lib/route-regexes';
import { type ComponentLike } from '@glint/template';
import type IntlService from 'ember-intl/services/intl';

interface Stamp {
  text: string;
  color:
    | 'gray'
    | 'green'
    | 'yellow-light'
    | 'sky'
    | 'blue'
    | 'red'
    | 'transparent'
    | 'yellow'
    | undefined;
}

export interface Breadcrumb {
  route: string;
  title: string;
  model?: Model;
  customComponent?: $TSFixMe;
}

interface Signature {
  Element: HTMLDivElement;
  Args: {
    titleToken?: string;
    shouldHideAppName?: boolean;
    newSettingHeader?: boolean;
    hideMenuToggle?: boolean;
    headingStamp?: Stamp;
    breadcrumbs?: Breadcrumb[];
    hideBottomBorder?: boolean;
    customHeaderTitle?: ComponentLike;
  };
  Blocks: {
    default: [];
  };
}

export default class StandardHeader extends Component<Signature> {
  @service declare router: RouterService;
  @service declare appService: AppService;
  @service declare intl: IntlService;

  get app() {
    return this.appService.app;
  }

  get breadcrumbs() {
    return this.args.breadcrumbs ?? this.defaultBreadcrumbs;
  }

  private get defaultBreadcrumbs() {
    if (this.appService.app.canUseStandalone) {
      return this.defaultStandaloneBreadcrumbs;
    } else {
      return [];
    }
  }

  private get defaultStandaloneBreadcrumbs(): Breadcrumb[] {
    if (this.isOnSettingsHomepage) {
      return [];
    }

    return [
      {
        route: 'apps.app.settings.index',
        title: this.intl.t('standalone.navbar.settings'),
      },
    ];
  }

  private get isOnSettingsHomepage() {
    return (
      this.router.currentRouteName === 'apps.app.settings.index' ||
      this.router.currentRouteName === 'apps.app.settings'
    );
  }

  get hideAppName() {
    let shouldHideAppNameOnHeader = this.args.shouldHideAppName ?? false;
    let isOnYourAccountSettingsRoute = RouteRegexes.accountSettings.root.test(
      this.router.currentRouteName,
    );

    return isOnYourAccountSettingsRoute || shouldHideAppNameOnHeader;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Settings::StandardHeader': typeof StandardHeader;
    'settings/standard-header': typeof StandardHeader;
  }
}
